import {
  RenderingProps,
  AnchorTargetParams,
  ImagePropertiesParams,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, RichTextField, LinkField, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C49ClickablePhotoContentCardProps = RenderingProps<
  C49ClickablePhotoContentCardFields,
  C49ClickablePhotoContentCardParams
>;

export type C49ClickablePhotoContentCardParams = {
  HeadlineTag?: string;
} & AnchorTargetParams &
  TranslationOptionsParams &
  ImagePropertiesParams;

export interface C49ClickablePhotoContentCardFields {
  Headline: Field<string>;
  SupportCopy?: RichTextField;
  Cta: LinkField;
  Image: ImageField;
  LinkTitle?: Field<string>;
}
